import _ from "lodash";

export function hydrateDeleteFloorPlan(data) {
  return {
    jsonData: data.data.jsonData,
    jobOrderId: data.data.jobOrderId,
    measurementId:data.data.measurementId,
  };
}
